(ns common.sessionstorage
  "Persist data with session storage. "
  (:refer-clojure :exclude [get])
  (:require [common.webstorage :as webstorage]
            [goog.storage.Storage]
            [goog.storage.mechanism.HTML5SessionStorage]))

(def storage (goog.storage.Storage. (goog.storage.mechanism.HTML5SessionStorage.)))

(defn get
  "Get a value from session storage by key"
  ([k] (webstorage/get storage k))
  ([k not-found] (webstorage/get storage k not-found)))

(defn save!
  "Saves a value into session storage"
  [k v]
  (webstorage/save! storage k v))

(defn remove!
  "Remove a value from session storage by key"
  [k]
  (webstorage/remove! storage k))
